import { TAGS, api } from "@/store/api"
import { balanceEndpoints } from "../balanceAPI"
import { personalDeckEndpoints } from "../personalDeckAPI"
import {
  STORE_CURRENCY,
  type ICreateInvoiceDto,
  type IStorePaymentInvoice
} from "./storePayments.types"

const basePath = "/store-payments"

export const storePaymentsApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.STORE_PAYMENTS]
})

export const storePaymentsEndpoints = storePaymentsApi.injectEndpoints({
  endpoints: (builder) => ({
    createInvoice: builder.mutation<IStorePaymentInvoice, ICreateInvoiceDto>({
      query: ({ itemId, amount, currency, itemType, price }) => ({
        url: `${basePath}/${itemId}/invoice`,
        method: "POST",
        data: {
          amount,
          currency,
          itemType,
          price
        }
      }),
      onQueryStarted: async (
        { currency, amount, price, cardId },
        { dispatch, queryFulfilled }
      ) => {
        const totalAmount = amount || 1 * price

        let patchBalance
        let patchCounter

        if (currency === STORE_CURRENCY.GOLDEN_DUST) {
          patchBalance = dispatch(
            balanceEndpoints.util.updateQueryData(
              "getBalance",
              undefined,
              (draft) => {
                draft.goldenDust -= totalAmount || 0
              }
            )
          )

          patchCounter = dispatch(
            personalDeckEndpoints.util.updateQueryData(
              "getPersonalDeckInventoryCounts",
              undefined,
              (draft) => {
                if (cardId && draft?.[cardId]) {
                  draft[cardId] = draft[cardId] + (amount || 0)
                }
              }
            )
          )
        }
        try {
          await queryFulfilled
        } catch {
          patchBalance?.undo()
          patchCounter?.undo()
        }
      }
    })
  })
})

export const { useCreateInvoiceMutation } = storePaymentsEndpoints
